import { getPersonalTrainerPackages } from '../../data/PersonalTrainerPackages'

// The package selector on the UAE / Malaysia pages is the Singapore
// PersonalTrainerBooking (components/market/PtSections MarketPtPackages).

// Lowest listed per-session price for a market (Signature, longest package).
export const lowestSessionPrice = (countryCd) =>
    Math.min(...getPersonalTrainerPackages(countryCd).Signature.packages.map((p) => p.perSessionPrice))
